(function () {
    "use strict";

    angular.module("app").component("habilScreeningAnswer", {
        templateUrl: "@/screening/screeningAnswer.html",
        bindings: {
            screening: "=",
            onReload: "=?",
            isForeign: "=",
            isInModal: "=?",
        },
        controller: ScreeningAnswerController,
        controllerAs: "vm"
    });

    ScreeningAnswerController.$inject = ["controllerDecorator", "screeningService", "enumService"];
    function ScreeningAnswerController(controllerDecorator, screeningService, enumService) {
        const vm = this;
        controllerDecorator.Decorate(vm, []);

        const screeningResultCodes = enumService.ScreeningResultCode;

        vm.REVISION_MIN_YEARS = 1;
        vm.REVISION_MAX_YEARS = 5;

        vm.$onInit = initializeComponent;

        vm.isReasonRequired = isReasonRequired;
        vm.validityPeriod = 0;

        vm.onFilesAdded = onFilesAdded;
        vm.deleteFile = deleteFile;
        vm.saveAnswer = saveAnswerAsync;

        vm.isBusy = false;

        vm.validityPeriodInput = {
            isRequired(screeningResult) {
                const resultCode = Number.parseInt(screeningResult, 10);

                return [screeningResultCodes.RASrevision, screeningResultCodes.AlternativeMeasure].includes(resultCode);
            },
            getLabel(screeningResult) {
                const resultCode = Number.parseInt(screeningResult, 10);

                if (resultCode === screeningResultCodes.RASrevision) {
                    return vm.getTranslation("ScreeningResult_RevisionAfter_Label");
                }
                else if (resultCode === screeningResultCodes.AlternativeMeasure) {
                    return vm.getTranslation("Screening_Result_ValidityPeriodInYears");
                }
            },
            getErrorMessage(screeningResult) {
                const resultCode = Number.parseInt(screeningResult, 10);

                let translationKey = null;
                if (resultCode === screeningResultCodes.RASrevision) {
                    translationKey = "ScreeningResult_RevisionAfter_Error";
                }
                else if (resultCode === screeningResultCodes.AlternativeMeasure) {
                    translationKey = "Screening_Result_ValidityPeriodInYears_Error";
                }

                if (translationKey === null)
                    return "";

                return vm.Utils.stringFormat(vm.getTranslation(translationKey), {
                    MIN_YEARS: vm.REVISION_MIN_YEARS,
                    MAX_YEARS: vm.REVISION_MAX_YEARS,
                });
            },
        };

        function initializeComponent() {
            if (!vm.screening)
                return;

            const initAsync = async () => {
                if (!vm.screening.Attachments?.length) {
                    await screeningService.getScreeningAttachments(vm.screening.PublicId).then(attachments => {
                        vm.screening.Attachments = [...attachments];
                    });
                }

                vm.resultCodeReason = "";

                vm.codeScreeningResultsCOL = screeningService.getPossibleScreeningResults(vm.screening);
            };

            initAsync();
        }

        function isReasonRequired(screeningResult) {
            return [screeningResultCodes.AdministrativeRefusal, screeningResultCodes.RASrevision, screeningResultCodes.AlternativeMeasure].includes(Number.parseInt(screeningResult, 10));
        }

        function deleteFile(attachment) {
            if (!attachment.PublicId || vm.guid.isEmpty(attachment.PublicId)) {
                removeItem(vm.screening.Attachments, attachment);
                return;
            }

            vm.SetLoadingState(true);

            vm.Api.DeleteScreeningAttachment(
                { AttachmentId: attachment.PublicId },
                _ => {
                    removeItem(vm.screening.Attachments, attachment);
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );

            function removeItem(array, item) {
                const index = array.indexOf(item);
                if (index !== -1)
                    array.splice(index, 1);
            }
        }

        async function saveAnswerAsync() {
            const screening = vm.screening;

            if (!screening || !screening.ResultCode
                || (isReasonRequired(screening.ResultCode) && !vm.resultCodeReason)
                || (vm.validityPeriodInput.isRequired(screening.ResultCode) && !vm.validityPeriod)) {
                return;
            }

            vm.isBusy = true;

            vm.SetLoadingState(true);

            screening.RestrictedRationale = vm.resultCodeReason;

            if (vm.validityPeriodInput.isRequired(screening.ResultCode)) {
                screening.RestrictedObservation = vm.validityPeriod;
            }

            screeningService.saveScreening(screening,
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    if (angular.isFunction(vm.onReload)) {
                        vm.onReload();
                    }

                    vm.ShowSuccess(vm.getTranslation("Actionbar_YourChangesHaveBeenSavedSuccessfully"));
                },
                vm.ShowError,
                () => {
                    vm.isBusy = false;

                    vm.SetLoadingState(false);
                });
        }

        function onFilesAdded(attachments) {
            if (attachments.length === 0)
                return;

            vm.screening.Attachments.push(...attachments);
        }
    }
})();